module.exports = "/images/id-step2en.png?95788de16381e8adca9e8f1a0d926084";